/**
 * Shared chrome polish for the revamped ("Final") dashboard shell — ported from
 * the Storybook `dashboard/final` reference (`attio-dashboard` design language).
 *
 * Everything here is scoped under `[data-final-shell]` so it never leaks into
 * portalled surfaces or the rest of the app: keyboard focus rings, tactile press
 * feedback, smooth anchor scrolling, and a faint grain overlay that breaks the
 * digital flatness of the white surface.
 */

/** SF Pro for the revamped shell (system font on Apple; graceful fallbacks).
 *  Exported so portalled surfaces (Sheets/Dialogs, which render outside the
 *  shell root) can opt back into the same typeface. */
export const FINAL_FONT =
  '"SF Pro Text", "SF Pro Display", -apple-system, BlinkMacSystemFont, system-ui, sans-serif';

const FINAL_GRAIN =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

export function FinalPolish() {
  return (
    <>
      <style>{`
[data-final-shell]{scroll-behavior:smooth;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
[data-final-shell] p{text-wrap:pretty}
[data-final-shell] h1,[data-final-shell] h2,[data-final-shell] h3{text-wrap:balance}
/* Buttons must not scale/move on press anywhere in the shell — feedback is the
   Button component's smooth background-darken (active:bg-*), never a transform. */
[data-final-shell] button:active{transform:none}
[data-final-shell] button:focus-visible,
[data-final-shell] [role=tab]:focus-visible,
[data-final-shell] a:focus-visible{outline:2px solid color-mix(in oklch, var(--color-accent) 60%, transparent);outline-offset:2px}
`}</style>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-[60] opacity-[0.025]"
        style={{ backgroundImage: FINAL_GRAIN }}
      />
    </>
  );
}
